module.exports = __webpack_public_path__ + "/images/logo-mercado-livre.1f0df4f.webp";